import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { queries } from '../../api/queries.js';
import { PublishPage } from '../../features/publish/PublishPage.js';

const publishSearch = z.object({
  subject: z.string().optional(),
  // In the URL for the same reason the tail's filter is: a narrowed picker is worth linking
  // to, and a reload should not widen it again.
  prefix: z.string().optional(),
});

export const Route = createFileRoute('/_app/publish')({
  validateSearch: publishSearch,
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(queries.events()),
  component: PublishPage,
});
